// extracted by mini-css-extract-plugin
export default {"container":"PU6ek47eCbqGBFZioarj","subtitle":"h90BhYRiku4i4BKsyAwM","copy":"C_KYuhF8wfzpfmvC8vUw"};